import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import getters from './getters.js';
import mutations from './mutations.js';
import actions from './actions.js'
import VueFormWizard from 'vue-form-wizard'
import VueSimpleAlert from "vue-simple-alert";

import excel from 'vue-excel-export'
Vue.use(excel)

Vue.use(VueSimpleAlert);
Vue.use(VueFormWizard)

Vue.use(Vuex)
Vue.use(VueAxios, axios)

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('access_token') || null,
    name: '',
    email: '',
    scores: null,
    balance: null,
    rates: null,
    transactions: null,
    adminTransactions: null,
    adminGameTransactions: null,
    rewards: null,
    adminRewards: null,
    adminFeatures: null,
    isAdmin: false,
    giftPayBalance: null,
    paymentMethods: null,
    paymentAmounts: null,
    showamount:0,
    showdaminamount:0,
    showkelamount:0,
    creditBalance:0,
    avatar:''
  },
  actions,
  mutations,
  getters,
  modules: {
  //  xmlformcontent
  }
})
